var scope_0 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/385e1041ca0805a667d626b373c77e59.js').default;
var scope_1 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ba6aa330cca587aee648a3bf909305ce.js').default;
var scope_2 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_3 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fd02be3bea87c3cab09161c09843534d.js').default;
var scope_4 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ff135a476f3025575a599c06ae52f4e5.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    